import { getActiveBrandId } from "./brandDeviceFilter";

/** C 端工坊用户接口与配置广场一致，仅支持 eweadn / exx */
export const UI_WORKSHOP_USER_BRAND_IDS = ["eweadn", "exx"] as const;
export type UiWorkshopUserBrandId = (typeof UI_WORKSHOP_USER_BRAND_IDS)[number];

/**
 * 解析工坊上传/套装/同步等 API 的 brand 参数。
 * 优先 catalog 已下发的品牌，其次构建品牌；非法值回退 eweadn。
 */
export function resolveUiWorkshopUserBrand(
  preferred?: string | null,
  activeBrandId: string = getActiveBrandId()
): UiWorkshopUserBrandId {
  const pick = (raw?: string | null): UiWorkshopUserBrandId | undefined => {
    if (!raw?.trim()) return undefined;
    const normalized = raw.trim().toLowerCase();
    if (normalized === "common") return "eweadn";
    if (
      (UI_WORKSHOP_USER_BRAND_IDS as readonly string[]).includes(normalized)
    ) {
      return normalized as UiWorkshopUserBrandId;
    }
    return undefined;
  };
  return pick(preferred) ?? pick(activeBrandId) ?? "eweadn";
}
